/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// Define a function to update the total cart item and price information 
function cart_drawer_update(){
  let tamount = ''; 
  let currencySymbol = $('#rash-cart-total-count').data('currency'); 
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          
           if (cart.item_count > 0) {
             tamount =   Number((cart.total_price / 100).toFixed(0) );  
              mainAmount = tamount.toLocaleString() ;             
            $('#rash-cart-total-count').text(`商品合計: ${cart.item_count} 点 ${currencySymbol}${mainAmount}`);
             console.log(cart.item_count); 
          } else {
             $('#rash-cart-total-count').text('No Item in cart'); 
          } 
           
        },
        error: function() {
          console.log('no-data found')
        /*  $('#total-cart').text('No data found');
          $('#total-amount').text('No data found');*/
        }
      });
}
$(document).ready(function() {
  $('.navlink--cart--icon').on('click', function() { 
    setTimeout(cart_drawer_update, 500); 
  });
  $('.product__submit__buttons').on('click', function() { 
    setTimeout(cart_drawer_update, 1500); 
  });
 

   $('.cart__total__price[data-cart-total]').on('DOMSubtreeModified', function() {
      let TotalPrice = $('.cart__total__price[data-cart-total]').text();
      $('.mainTotal').text(TotalPrice);
      console.log('changed');
  });
 
 
});  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
